import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import dynamicfunction from '../../../utils/dynamicfunction';
import { getContentKeyAccToLang, showToast } from '../../../utils/utils';
import { getKycUploadDocumentVault, getUploadDocuments, updateKycDocument } from '../../../store/actions/corporateAction';
import { UploadCard, RowView } from '../../CorporateForm/components';
import Button from '../../../components/Button';
import { getIndDocumentVaultData, postIndDocumentVault, postIndKycDocumentVault } from '../../../store/actions/individualAction';
import { Formik } from 'formik';
import { logoutUser } from '../../../store/actions/authActions';
import { useNavigate } from 'react-router';

const DocumentVault = ({ onDone }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isArabic, direction } = dynamicfunction();

  const { individualContent, language } = useSelector((state) => state.content);
  const { ind_post_loading, ind_document_vault_data } = useSelector((state) => state.individual);

  const { client_application_id, is_kyc, applicant_type } = useSelector((state) => state.constant);

  const getContent = (key) => {
    return getContentKeyAccToLang(individualContent?.document_vault?.data?.attributes, key, isArabic);
  };

  useEffect(() => {
    getData();
  }, [language]);

  const getData = async () => {
    await dispatch(
      getIndDocumentVaultData(client_application_id),
    );
  }

  const onSubmit = (values) => {
    const MAX_SIZE = 2 * 1024 * 1024; // 2MB
    const documents = Object.entries(values)
      // .filter(([key, value]) => value.file !== null)
      .filter(([key, value]) => key !== "isSaveExist" && value?.file)
      .map(([key, value]) => {
        // FILE SIZE VALIDATION
        if (value?.file?.size > MAX_SIZE) {
          showToast({
            icon: "error",
            title: `${key} ${getContent('document_size_validation')}`,
          });
          throw new Error("File size limit exceeded");
        }

        return {
          key,
          ...value,
        };
      });

    const formData = new FormData();

    formData.append('ClientApplicationId', client_application_id);

    if (documents?.length < 1) {
      formData.append('Documents', []);
    } else {
      documents.forEach((doc, index) => {
        if (doc?.file) {
          formData.append(`Documents[${index}].FileData`, doc.file);
          formData.append(`Documents[${index}].DocumentTypeId`, doc.DocumentTypeId);
        }
      });
    }

    is_kyc
      ? dispatch(
        postIndKycDocumentVault(formData, () => {
          values?.isSaveExist ? navigate('/funds/available-funds') : onDone();
        }),
      )
      : dispatch(
        postIndDocumentVault(formData, () => {
          values?.isSaveExist ? dispatch(logoutUser()) : onDone();
        }),
      );
  };

  const is_ksa_resident = applicant_type === 'KSA Resident';
  const is_ksa_national = applicant_type === 'KSA National';
  const is_non_ksa = !is_ksa_resident && !is_ksa_national;

  const uploadDocument = (id, file) => {
    const formData = new FormData();
    formData.append('ClientApplicationId', client_application_id);
    formData.append('DocumentTypeId', id);
    formData.append('Document', file);

    dispatch(
      updateKycDocument(formData, () => {
        dispatch(
          is_kyc ? getKycUploadDocumentVault(client_application_id) : getUploadDocuments(client_application_id), //
        );
      }),
    );
  };

  const getFileName = (id) => ind_document_vault_data?.find((item) => item.documentTypeId === id)?.fileName ?? null;

  const onPressDelete = (id, setFieldValue, key) => {
    setFieldValue(key, {
      DocumentTypeId: id?.toString(),
      name: null,
      file: null,
      type: null,
    });
  };

  const onPressSubmit = (values) => {
    const is_national = values?.NationalIdCard?.name?.length > 0 && values?.TaxComplianceLaw?.name?.length > 0
    const is_resident = values?.ResidencePermitResidenceId?.name?.length > 0 && values?.TaxComplianceLaw?.name?.length > 0 &&
      values?.FiveYearResidenceCard?.name?.length > 0 && values?.LetterOfIntroduction?.name?.length > 0 && values?.DiplomaticMission?.name?.length > 0
    const is_non_ksa = values?.NationalIdCard?.name?.length > 0 && values?.TaxComplianceLaw?.name?.length > 0 && values?.CopyValidPassport?.name?.length > 0

    const is_valid = is_ksa_national ? is_national : is_ksa_resident ? is_resident : is_non_ksa

    if (!is_valid) {
      showToast({
        icon: "error",
        title: getContent('upload_all_document_validation'),
      });
      return
    }
    onSubmit(values)
  }

  return (
    <>
      <div>
        <Formik
          enableReinitialize
          initialValues={{
            NationalIdCard: {
              DocumentTypeId: '805',
              name: getFileName(805),
              file: null,
              type: null,
            },
            TaxComplianceLaw: {
              DocumentTypeId: '806',
              name: getFileName(806),
              file: null,
              type: null,
            },
            CopyValidPassport: {
              DocumentTypeId: '807',
              name: getFileName(807),
              file: null,
              type: null,
            },
            ResidencePermitResidenceId: {
              DocumentTypeId: '1034',
              name: getFileName(1034) ?? null,
              file: null,
              type: null,
            },
            FiveYearResidenceCard: {
              DocumentTypeId: '1035',
              name: getFileName(1035) ?? null,
              file: null,
              type: null,
            },
            DiplomaticMission: {
              DocumentTypeId: '1554',
              name: getFileName(1554) ?? null,
              file: null,
              type: null,
            },
            LetterOfIntroduction: {
              DocumentTypeId: '1553',
              name: getFileName(1553) ?? null,
              file: null,
              type: null,
            },
            isSaveExist: false,
          }}
          // validationSchema={individual_document_vault_schema()}
          validationContext={{}}
          onSubmit={(values) => {
            onPressSubmit(values);
          }}
          validationOnChange={true}
          validateOnBlur={false}
        >
          {({ handleSubmit, setFieldValue, values, errors }) => {

            return (
              <div>
                {is_ksa_national && (
                  <>
                    <div dir={direction} className='grid grid-cols-1 md:grid-cols-2 gap-10'>
                      <UploadCard
                        title={getContent('copy_of_national_id_card')}
                        description={getContent('file_instructions')}
                        upload={getContent('upload')}
                        name={values?.NationalIdCard?.name}
                        isRequired
                        onClick={(file) => {
                          const obj = {
                            name: file.name,
                            file: file,
                            type: file.type,
                            DocumentTypeId: values?.NationalIdCard?.DocumentTypeId,
                          };
                          setFieldValue('NationalIdCard', obj);
                        }}
                        onDeleteDocument={() => onPressDelete(805, setFieldValue, "NationalIdCard")}
                      />
                      <UploadCard
                        title={getContent('self_declaration_comply_with_tax_compliance_law')}
                        description={getContent('file_instructions')}
                        upload={getContent('upload')}
                        name={values?.TaxComplianceLaw?.name}
                        isRequired
                        onClick={(file) => {
                          const obj = {
                            name: file.name,
                            file: file,
                            type: file.type,
                            DocumentTypeId: values?.TaxComplianceLaw?.DocumentTypeId,
                          };
                          setFieldValue('TaxComplianceLaw', obj);
                        }}
                        onDeleteDocument={() => onPressDelete(806, setFieldValue, "TaxComplianceLaw")}
                      />
                    </div>
                  </>
                )}
                {is_ksa_resident && (
                  <>
                    <div dir={direction} className='grid grid-cols-1 md:grid-cols-2 gap-10 pt-3 sm:pt-5'>
                      <UploadCard
                        title={getContent('copy_of_valid_residence_permit')}
                        description={getContent('file_instructions')}
                        upload={getContent('upload')}
                        name={values?.ResidencePermitResidenceId?.name}
                        isRequired
                        onClick={(file) => {
                          const obj = {
                            name: file.name,
                            file: file,
                            type: file.type,
                            DocumentTypeId: values?.ResidencePermitResidenceId?.DocumentTypeId,
                          };
                          setFieldValue('ResidencePermitResidenceId', obj);
                        }}
                        onDeleteDocument={() => onPressDelete(1034, setFieldValue, "ResidencePermitResidenceId")}
                      />
                      <UploadCard
                        title={getContent('self_declaration_comply_with_tax_compliance_law')}
                        description={getContent('file_instructions')}
                        upload={getContent('upload')}
                        name={values?.TaxComplianceLaw?.name}
                        isRequired
                        onClick={(file) => {
                          const obj = {
                            name: file.name,
                            file: file,
                            type: file.type,
                            DocumentTypeId: values?.TaxComplianceLaw?.DocumentTypeId,
                          };
                          setFieldValue('TaxComplianceLaw', obj);
                        }}
                        onDeleteDocument={() => onPressDelete(806, setFieldValue, "TaxComplianceLaw")}
                      />
                    </div>
                    <div dir={direction} className='grid grid-cols-1 md:grid-cols-2 gap-10 pt-3 sm:pt-5'>
                      <UploadCard
                        title={getContent('copy_of_five_years_residence_card')}
                        description={getContent('file_instructions')}
                        upload={getContent('upload')}
                        name={values?.FiveYearResidenceCard?.name}
                        isRequired
                        onClick={(file) => {
                          const obj = {
                            name: file.name,
                            file: file,
                            type: file.type,
                            DocumentTypeId: values?.FiveYearResidenceCard?.DocumentTypeId,
                          };
                          setFieldValue('FiveYearResidenceCard', obj);
                        }}
                        onDeleteDocument={() => onPressDelete(1035, setFieldValue, "FiveYearResidenceCard")}
                      />
                      <UploadCard
                        title={getContent('letter_of_introduction')}
                        description={getContent('file_instructions')}
                        upload={getContent('upload')}
                        name={values?.LetterOfIntroduction?.name}
                        isRequired
                        onClick={(file) => {
                          const obj = {
                            name: file.name,
                            file: file,
                            type: file.type,
                            DocumentTypeId: values?.LetterOfIntroduction?.DocumentTypeId,
                          };
                          setFieldValue('LetterOfIntroduction', obj);
                        }}
                        onDeleteDocument={() => onPressDelete(1553, setFieldValue, "LetterOfIntroduction")}
                      />
                    </div>
                    <div dir={direction} className='grid grid-cols-1 md:grid-cols-2 gap-10 pt-3 sm:pt-5'>
                      <UploadCard
                        title={getContent('copy_of_diplomatic_carn')}
                        description={getContent('file_instructions')}
                        upload={getContent('upload')}
                        name={values?.DiplomaticMission?.name}
                        isRequired
                        onClick={(file) => {
                          const obj = {
                            name: file.name,
                            file: file,
                            type: file.type,
                            DocumentTypeId: values?.DiplomaticMission?.DocumentTypeId,
                          };
                          setFieldValue('DiplomaticMission', obj);
                        }}
                        onDeleteDocument={() => onPressDelete(1554, setFieldValue, "DiplomaticMission")}
                      />
                    </div>
                  </>
                )}
                {is_non_ksa && (
                  <>
                    <div dir={direction} className='grid grid-cols-1 md:grid-cols-2 gap-10 pt-3 sm:pt-5'>
                      <UploadCard
                        title={getContent('copy_of_national_id_card')}
                        description={getContent('file_instructions')}
                        upload={getContent('upload')}
                        name={values?.NationalIdCard?.name}
                        isRequired
                        onClick={(file) => {
                          const obj = {
                            name: file.name,
                            file: file,
                            type: file.type,
                            DocumentTypeId: values?.NationalIdCard?.DocumentTypeId,
                          };
                          setFieldValue('NationalIdCard', obj);
                        }}
                        onDeleteDocument={() => onPressDelete(805, setFieldValue, "NationalIdCard")}
                      />
                      <UploadCard
                        title={getContent('self_declaration_comply_with_tax_compliance_law')}
                        description={getContent('file_instructions')}
                        upload={getContent('upload')}
                        name={values?.TaxComplianceLaw?.name}
                        isRequired
                        onClick={(file) => {
                          const obj = {
                            name: file.name,
                            file: file,
                            type: file.type,
                            DocumentTypeId: values?.TaxComplianceLaw?.DocumentTypeId,
                          };
                          setFieldValue('TaxComplianceLaw', obj);
                        }}
                        onDeleteDocument={() => onPressDelete(806, setFieldValue, "TaxComplianceLaw")}
                      />
                    </div>
                    <div dir={direction} className='grid grid-cols-1 md:grid-cols-2 gap-10 pt-3 sm:pt-5'>
                      <UploadCard
                        title={getContent('copy_of_valid_passport')}
                        description={getContent('file_instructions')}
                        upload={getContent('upload')}
                        name={values?.CopyValidPassport?.name}
                        isRequired
                        onClick={(file) => {
                          const obj = {
                            name: file.name,
                            file: file,
                            type: file.type,
                            DocumentTypeId: values?.CopyValidPassport?.DocumentTypeId,
                          };
                          setFieldValue('CopyValidPassport', obj);
                        }}
                        onDeleteDocument={() => onPressDelete(807, setFieldValue, "CopyValidPassport")}
                      />
                    </div>
                  </>
                )}

                <div className='w-full h-0.5 bg-border mt-3 sm:mt-5'></div>
                <RowView className='gap-3 sm:gap-7 pt-3 sm:pt-5'>
                  <Button
                    text={getContent('save_proceed')}
                    color={'text-white hover:text-primary '}
                    bgColor='bg-primary hover:bg-transparent hover:border-primary'
                    className={'border border-transparent w-44 px-0 text-center'}
                    isDisabled={ind_post_loading}
                    loading={ind_post_loading}
                    onClick={() => {
                      setFieldValue('isSaveExist', false);
                      handleSubmit();
                    }}
                  />
                  <Button
                    text={getContent('save_exit')}
                    color={'text-primary hover:text-white'}
                    bgColor='bg-white hover:bg-primary'
                    className={'border border-primary w-44 px-0 text-center'}
                    isDisabled={ind_post_loading}
                    onClick={() => {
                      setFieldValue('isSaveExist', true);
                      handleSubmit();
                    }}
                  />
                </RowView>
              </div>
            );
          }}
        </Formik>
        {/* <div dir={isArabic ? 'rtl' : 'ltr'} className='grid grid-cols-1 md:grid-cols-2 gap-10'>
          {document_types?.map((doc) => {
            const existingDoc = uploaded_documents?.find((d) => d?.documentTypeId === doc?.id);
            return (
              
            );
          })}
        </div> */}
      </div>
    </>
  );
};

export default DocumentVault;
